<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <p style="margin-top:-10px">
                        Roma Formazione Srl, che opera nella Regione Lazio con l’insegna di Roma Formazione Srl è un Soggetto che eroga attività di formazione della Regione Lazio a norma della DGR n. 682 del 01/10/2019.
                    </p>
                        <div class="row pt-3">
                            <div class="col-12 p-0" align="left">
                                <a href="https://apps.apple.com/it/app/discentya/id6468484981" target="_blank">
                                    <img src="assets/img/applestore-badge-white.png" style="width: 160px;">
                                    <img src="assets/img/googlestore-badge-white.png" class="ms-3" style="width: 160px;">
                                </a>
                            </div>
                        </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>LINK</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>LOGIN</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Menù</a></li>
                        <li><a href="#" target="_blank">Docenti/Tutor</a></li>
                        <li><a href="#" target="_blank">Partner</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>DOVE SIAMO</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i> Viale Francesco Antolisei 25<br>00173 Roma</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+393518185207">Telefono: (+39) 3518185207</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:coordinamento@romaformazione.it">coordinamento@romaformazione.it</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+393518185207">Lunedì-Venerdì<br>09:00 ÷ 18:00</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2026 Roma Formazione - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2 d-none">
                    <ul>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
